import { AssetTypeStatusService as OvermapAssetTypeStatusService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AssetTypeStatusService extends OvermapAssetTypeStatusService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
